var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$route.name =='Commissions - View By Commissions')?_c('view-by-commission-table'):(this.$route.name =='Commissions - View By Brokers')?_c('view-by-broker-table'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }